const CogIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_239_1990)">
        <path
          d="M7.47142 3.21387L8.0857 1.62815C8.1893 1.35967 8.37157 1.12874 8.60863 0.965599C8.8457 0.802459 9.1265 0.714717 9.41427 0.713867H10.5857C10.8735 0.714717 11.1543 0.802459 11.3913 0.965599C11.6284 1.12874 11.8107 1.35967 11.9143 1.62815L12.5286 3.21387L14.6142 4.41387L16.2999 4.15672C16.5806 4.11862 16.8664 4.16482 17.1208 4.28947C17.3751 4.41411 17.5866 4.61155 17.7285 4.85672L18.2999 5.85672C18.4464 6.1058 18.5139 6.39341 18.4935 6.68161C18.4731 6.96981 18.3658 7.24505 18.1856 7.47101L17.1428 8.79958V11.1996L18.2142 12.5282C18.3944 12.7541 18.5016 13.0294 18.5221 13.3176C18.5425 13.6058 18.4749 13.8934 18.3285 14.1424L17.7571 15.1424C17.6152 15.3876 17.4036 15.585 17.1494 15.7097C16.8949 15.8343 16.6092 15.8806 16.3285 15.8424L14.6428 15.5853L12.5571 16.7853L11.9428 18.371C11.8392 18.6394 11.657 18.8704 11.4199 19.0336C11.1829 19.1967 10.902 19.2844 10.6143 19.2853H9.41427C9.1265 19.2844 8.8457 19.1967 8.60863 19.0336C8.37157 18.8704 8.1893 18.6394 8.0857 18.371L7.47142 16.7853L5.3857 15.5853L3.69999 15.8424C3.4193 15.8806 3.13362 15.8343 2.87925 15.7097C2.62489 15.585 2.41332 15.3876 2.27142 15.1424L1.69999 14.1424C1.55356 13.8934 1.4861 13.6058 1.5065 13.3176C1.5269 13.0294 1.63422 12.7541 1.81427 12.5282L2.85713 11.1996V8.79958L1.7857 7.47101C1.60565 7.24505 1.49833 6.96981 1.47793 6.68161C1.45753 6.39341 1.52499 6.1058 1.67142 5.85672L2.24285 4.85672C2.38475 4.61155 2.59632 4.41411 2.85067 4.28947C3.10505 4.16482 3.39073 4.11862 3.67142 4.15672L5.35713 4.41387L7.47142 3.21387Z"
          stroke="currentColor"
          strokeWidth="1.71429"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_239_1990">
          <rect width="20" height="20" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CogIcon;
